import { InsightSEO } from "@/hooks/useInsightSEO";
import { InsightsNavbar } from "@/components/InsightsNavbar";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { AnimatedSection } from "@/components/AnimatedSection";
import { Footer } from "@/components/Footer";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { TableOfContents } from "@/components/TableOfContents";

import { PMToolsHeroSection } from "@/components/insights/pm-tools/PMToolsHeroSection";
import { PMToolsTakeaway } from "@/components/insights/pm-tools/PMToolsTakeaway";
import { PMToolsFounderQuote } from "@/components/insights/pm-tools/PMToolsFounderQuote";
import { PMToolsComparison } from "@/components/insights/pm-tools/PMToolsComparison";
import { PMToolsDetails } from "@/components/insights/pm-tools/PMToolsDetails";
import { PMToolsDecisionGuide } from "@/components/insights/pm-tools/PMToolsDecisionGuide";
import { PMToolsCalculator } from "@/components/insights/pm-tools/PMToolsCalculator";
import { PMToolsFAQSection } from "@/components/insights/pm-tools/PMToolsFAQSection";

const ProjectManagementComparison = () => {
  return (
    <>
      <InsightSEO 
        slug="project-management-tools" 
        additionalKeywords={[
          "Lottae",
          "project management software",
          "Asana alternative",
          "Monday.com alternative",
          "Trello alternative",
          "Jira alternative",
          "team collaboration",
          "workflow management",
          "best PM tools 2025",
          "affordable project management",
          "project management comparison",
          "Lottae vs Asana",
          "Lottae pricing",
        ]}
      />
      <InsightEngagementTracker slug="project-management-tools" title="Project Management Tools Comparison" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Productivity" 
          categorySlug="/?category=Productivity"
          currentPage="Project Management Tools" 
        />
        
        <PMToolsHeroSection />
        
        <AnimatedSection delay={100}>
          <PMToolsTakeaway />
        </AnimatedSection>
        
        <AnimatedSection delay={150}>
          <PMToolsFounderQuote />
        </AnimatedSection>
        
        <AnimatedSection delay={200}>
          <PMToolsComparison />
        </AnimatedSection>
        
        <AnimatedSection delay={250}>
          <PMToolsCalculator />
        </AnimatedSection>
        
        <AnimatedSection delay={300}>
          <PMToolsDetails />
        </AnimatedSection>
        
        <AnimatedSection delay={300}>
          <PMToolsDecisionGuide />
        </AnimatedSection>
        
        <AnimatedSection delay={350}>
          <PMToolsFAQSection />
        </AnimatedSection>
        
        {/* Related Tools Section */}
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="project-management-tools" />
        </AnimatedSection>
      </main>
      
      <Footer />
    </>
  );
};

export default ProjectManagementComparison;
